var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#C4F538",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8334 28.125V23.125M23.3334 25.625H28.3334M20.0001 23.125H16.6667C15.1136 23.125 14.337 23.125 13.7245 23.3787C12.9077 23.717 12.2588 24.366 11.9205 25.1827C11.6667 25.7953 11.6667 26.5719 11.6667 28.125M22.9167 13.3673C24.1383 13.8618 25.0001 15.0594 25.0001 16.4583C25.0001 17.8572 24.1383 19.0549 22.9167 19.5494M21.2501 16.4583C21.2501 18.2993 19.7577 19.7917 17.9167 19.7917C16.0758 19.7917 14.5834 18.2993 14.5834 16.4583C14.5834 14.6174 16.0758 13.125 17.9167 13.125C19.7577 13.125 21.2501 14.6174 21.2501 16.4583Z",
    stroke: "#C4F538",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/invite-icon.65617959b9bdeb7375f470c10a8d57a5.svg";
export { ForwardRef as ReactComponent };